module.exports = __webpack_public_path__ + "static/media/davide-berruto-photo-2.1b8cee0e.jpg";